if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls } = window.wp.editor;
    const { PanelBody, TextControl, SelectControl, CheckboxControl } = window.wp.components;

    const COLORS = [
        { label: 'Primary', value: 'primary' },
        { label: 'Dark', value: 'dark' },
        { label: 'Light', value: 'light' },
        { label: 'Muted', value: 'muted' },
        { label: 'White', value: 'white' }
    ];

    function getButtonClasses(attributes) {
        return 'btn btn-' + attributes.backgroundColor + ' text-' + attributes.textColor;
    }

    registerBlockType('custom-gutenberg/cta', {
        // built-in attributes
        title: 'Button',
        description: 'Button with Saorsa background and text colours.',
        icon: 'button',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: { type: 'string', default: '' },
            openInNewTab: { type: 'boolean', default: false },
            text: { type: 'string', default: 'Saznaj više' },
            backgroundColor: { type: 'string', default: 'primary' },
            textColor: { type: 'string', default: 'dark' }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {
            const { link, text, backgroundColor, textColor } = attributes;

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Settings">
                        <TextControl label="Link" value={ link } onChange={ link => setAttributes({ link: link }) } />
                        <CheckboxControl label="Open in new tab" checked={ attributes.openInNewTab } onChange={ openInNewTab => setAttributes({ openInNewTab: openInNewTab }) } />
                        <TextControl label="Text" value={ text } onChange={ text => setAttributes({ text: text }) } />
                        <SelectControl label="Background colour" value={ backgroundColor } options={ COLORS } onChange={ backgroundColor => setAttributes({ backgroundColor: backgroundColor }) } />
                        <SelectControl label="Text colour" value={ textColor } options={ COLORS } onChange={ textColor => setAttributes({ textColor: textColor }) } />
                    </PanelBody>
                </InspectorControls>,
                <div key="preview" className={ getButtonClasses(attributes) }>{ text }</div>
            ]);
        },

        save({ attributes }) {
            const { link, text } = attributes;
            const ElemTag = link ? 'a' : 'div';

            return (
                <ElemTag href={ link || undefined } target={ link && attributes.openInNewTab ? '_blank' : undefined } rel={ link && attributes.openInNewTab ? 'noopener noreferrer' : undefined } className={ getButtonClasses(attributes) }>{ text }</ElemTag>
            );
        },

        // Preserve existing saved buttons when opening older page content.
        deprecated: [{
            attributes: {
                link: { type: 'string', default: '' },
                text: { type: 'string', default: 'Saznaj više' },
                type: { type: 'string', default: '' }
            },
            migrate({ link, text, type }) {
                return {
                    link: link,
                    text: text,
                    backgroundColor: type.indexOf('btn-dark') !== -1 ? 'dark' : 'primary',
                    textColor: type.indexOf('text-white') !== -1 || type.indexOf('btn-dark') !== -1 ? 'white' : 'dark'
                };
            },
            save({ attributes }) {
                const { link, text, type } = attributes;
                const ElemTag = link ? 'a' : 'div';
                return <ElemTag href={ link } className={ 'btn cta-btn ' + type }>{ text }</ElemTag>;
            }
        }]
    });
}
